"use strict";
import _ from "lodash";

export class ColorService {
    constructor({ ThemesService } = {}) {
        this.ThemesService = ThemesService;

        this.ColorsChart = ThemesService.getDashboardTheme();
    }

    static backgroundColor = (className) => {
        const classes = {
            positive: "bg-positive",
            negative: "bg-negative",
            error: "bg-inconsistency",
            warning: "bg-warning",
            neutro: "bg-neutro",
            inconsistency: "bg-inconsistency",
            "positive-linear": "bg-positive-linear",
            "negative-linear": "bg-negative-linear",
            "error-linear": "bg-error-linear",
            "warning-linear": "bg-warning-linear",
            "neutro-linear": "bg-neutro-linear",
            "basic-linear": "basic-linear",
            "inconsistency-linear": "bg-inconsistency-linear"
        };
        return classes[className];
    };

    static backgroundImage = (backgroundColor) => {
        const images = {
            "bg-positive": "bg-image-cyan",
            "bg-negative": "bg-image-purple",
            "bg-neutro": "bg-image-magenta",
            "bg-error": "bg-image-error",
            "bg-warning": "bg-image-warning"
        };

        return images[backgroundColor];
    };

    /**
     * Identify a color by your pathName in json
     * @public
     * @param {String} path
     * @return {String} Value of path
     */
    colorByPath(pathName) {
        const theme = this.ThemesService.getTheme();

        let color = _.get(this.ColorsChart, `${pathName}.${theme}`);

        if (!color) color = _.get(this.ColorsChart, `${pathName}.light`);

        return color;
    }

    setColorsChart() {
        this.ColorsChart = this.ThemesService.getDashboardTheme();
    }

    getLowerTonality(pathName) {
        if (!pathName) return "";
        const shades = {
            darker: "light",
            dark: "light",
            medium: "light",
            light: "light",
            lighter: "light",
            petroleum: "petroleum"
        };
        const color = pathName.split(".");
        const tonality = color[1];
        const newTonality = shades[tonality];
        if (!newTonality) return "light";
        return `${color[0]}.${newTonality}`;
    }
}
